import { useEffect, useContext } from 'react';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import useCustomHook from '@/hooks/useCustomHook';

export default function useSongActivity({ activity }) {
  const globalContext = useContext(GlobalContext);
  const { state, actions } = useCustomHook({
    defaultState: {
      lyricsImage: null,
      showLyrics: false,
    },
  });

  useEffect(() => {
    if (activity?.data && globalContext.state.loaded) {
      if (!activity.data?.karaokeCues) {
        actions.setState({
          showLyrics: true,
          lyricsImage: getLyricsImage(activity.description),
        });
      }
    }
  }, [activity, globalContext.state]);

  return { state };
}

function getLyricsImage(description) {
  const virtualDescDiv = document.createElement('div');
  virtualDescDiv.innerHTML = description;
  const imgNode = virtualDescDiv.querySelector('img');
  return imgNode
    ? {
        src: imgNode.src,
        width: imgNode.width || imgNode.style.width.replace('px', ''),
        height: imgNode.height || imgNode.style.height.replace('px', ''),
      }
    : null;
}
